<template>
  <ToolDropWithButtons
    :options="options"
    :is-active="editor.isActive('orderedList')"
    :components="components"
    :set="() => editor.chain().focus().toggleOrderedList().run()"
    data-testid="ordered-list-button"
    tooltip="Ordered list"
  >
    <ListDecimal />
  </ToolDropWithButtons>
</template>
<script setup lang="ts">
import ToolDropWithButtons from "../_internal/ToolDropWithButtons.vue";
import {
  ListDecimal,
  ListLowerAlpha,
  ListLowerGreek,
  ListLowerRoman,
  ListUpperAlpha,
  ListUpperRoman,
} from "@topol/icons";
import { Editor } from "@tiptap/core";
import { computed } from "vue";

const components = {
  ListDecimal,
  ListLowerAlpha,
  ListLowerGreek,
  ListLowerRoman,
  ListUpperAlpha,
  ListUpperRoman,
};

const props = defineProps<{
  editor: Editor;
  language?: string;
}>();

const options = computed(() => {
  return [
    {
      icon: "ListDecimal",
      set: () => {
        const chain = props.editor.chain().focus();
        if (!props.editor.isActive("orderedList")) {
          chain.toggleOrderedList();
        }
        chain
          .updateAttributes("orderedList", { listStyleType: "decimal" })
          .run();
      },
      isActive: props.editor.isActive("orderedList", {
        listStyleType: "decimal",
      }),
    },
    {
      icon: "ListLowerAlpha",
      set: () => {
        const chain = props.editor.chain().focus();
        if (!props.editor.isActive("orderedList")) {
          chain.toggleOrderedList();
        }
        chain
          .updateAttributes("orderedList", { listStyleType: "lower-alpha" })
          .run();
      },
      isActive: props.editor.isActive("orderedList", {
        listStyleType: "lower-alpha",
      }),
    },
    {
      icon: "ListLowerGreek",
      set: () => {
        const chain = props.editor.chain().focus();
        if (!props.editor.isActive("orderedList")) {
          chain.toggleOrderedList();
        }
        chain
          .updateAttributes("orderedList", { listStyleType: "lower-greek" })
          .run();
      },
      isActive: props.editor.isActive("orderedList", {
        listStyleType: "lower-greek",
      }),
    },
    {
      icon: "ListLowerRoman",
      set: () => {
        const chain = props.editor.chain().focus();
        if (!props.editor.isActive("orderedList")) {
          chain.toggleOrderedList();
        }
        chain
          .updateAttributes("orderedList", { listStyleType: "lower-roman" })
          .run();
      },
      isActive: props.editor.isActive("orderedList", {
        listStyleType: "lower-roman",
      }),
    },
    {
      icon: "ListUpperAlpha",
      set: () => {
        const chain = props.editor.chain().focus();
        if (!props.editor.isActive("orderedList")) {
          chain.toggleOrderedList();
        }
        chain
          .updateAttributes("orderedList", { listStyleType: "upper-alpha" })
          .run();
      },
      isActive: props.editor.isActive("orderedList", {
        listStyleType: "upper-alpha",
      }),
    },
    {
      icon: "ListUpperRoman",
      set: () => {
        const chain = props.editor.chain().focus();
        if (!props.editor.isActive("orderedList")) {
          chain.toggleOrderedList();
        }
        chain
          .updateAttributes("orderedList", { listStyleType: "upper-roman" })
          .run();
      },
      isActive: props.editor.isActive("orderedList", {
        listStyleType: "upper-roman",
      }),
    },
  ];
});
</script>
